import React from 'react';
import PropTypes from 'prop-types';
import { isIOS } from '../../libs/utils/deviceDetector'

const DownloadButton = ({ src }) => (isIOS ? null : (
  <a
    className="download-btn"
    href={src}
    download
    aria-label="download"
  >
    <svg viewBox="0 0 32 32" focusable="false">
      <circle cx="16" cy="16" r="16" fill="#000" />
      <path fill="#fff" d="M23 20v2a1 1 0 0 1-1 1H10a1 1 0 0 1-1-1v-2a1 1 0 0 0-1-1 1 1 0 0 0-1 1v3a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-3a1 1 0 0 0-1-1 1 1 0 0 0-1 1z" />
      <path fill="#fff" d="M21 13.2a1 1 0 0 0-1.4 0L17 15.7V7.8a.8.8 0 0 0-.8-.8h-.4a.8.8 0 0 0-.8.8v7.9l-2.5-2.5a1 1 0 1 0-1.5 1.4l4.2 4.2a1 1 0 0 0 1.4 0l4.4-4.2a1 1 0 0 0 0-1.4z" />
    </svg>
  </a>
))

if (process.env.NODE_ENV !== 'production') {
  DownloadButton.propTypes = {
    src: PropTypes.string,
  };
}

export default DownloadButton;
